export default "__VITE_PUBLIC_ASSET__48131563__"